/**
 * Why Place Order is disabled, as data rather than as a boolean.
 *
 * Extracted from CheckoutPage.jsx (card 53682) so it can be exercised directly: the jest
 * config here is `transform: {}` with `moduleFileExtensions: ['js','mjs','json']`, so a
 * `.jsx` page cannot be imported by a test at all. The page's behaviour is unchanged — it
 * imports this and calls it exactly as before.
 *
 * Deriving the reasons as a NAMED LIST is what lets the button say WHY it is disabled instead
 * of just going grey — a silent grey button sent a real customer back through intake three
 * times without /checkout/submit ever being sent.
 *
 * Order matters: the subscription terms come first because they are signed in a modal reached
 * from far up the page, so they are the blocker a customer is least likely to find on their own.
 */
export const derivePlaceOrderBlockers = ({
  legalConsentAgreed,
  pricing,
  pricingError,
  subscriptionClauseAgreed,
  subscriptionConsentData,
}) => [
  ...(subscriptionClauseAgreed && subscriptionConsentData
    ? []
    : [{
        key: 'subscription',
        label: 'Review and sign the Subscription Terms & Conditions',
        actionLabel: 'Review & Sign Terms',
      }]),
  ...(legalConsentAgreed
    ? []
    : [{ key: 'disclosures', label: 'Agree to the Important Disclosures directly above' }]),
  // Not customer-actionable from the consent area — surface the message itself rather than
  // pointing at a checkbox that cannot clear it.
  ...(pricingError ? [{ key: 'pricing', label: `Pricing could not be confirmed: ${pricingError}` }] : []),
  // No price was ever LOADED. This is the structural half of the gate and it is deliberately
  // NOT folded into `pricingError`: `product` and `pricing` arrive on two different requests
  // (`GET /products/:slug` then `POST /checkout`), and only `product` gates the render, so a
  // failed pricing POST leaves the page fully interactive with no total on it. Submitting from
  // that state sends `expectedTotal: null`, which checkPricingMismatch reads as "no opinion"
  // (api/controllers/checkoutController.js) — disabling the one check that makes a member pay
  // the price they were shown, exactly when the client never learned it. Derived from state
  // rather than from remembering to set a flag at each failure site, so a new failure path
  // cannot reopen the hole.
  ...(pricing ? [] : [{ key: 'pricingMissing', label: 'Pricing could not be loaded — refresh to see your total before ordering' }]),
];
